import type { AdminSuggestion, ILocationRepository } from '../repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

export function createAutocompleteLocationAdminUseCase({ locationRepository }: Deps) {
  return async function autocompleteLocationAdmin(orgId: string, query: string): Promise<AdminSuggestion[]> {
    return locationRepository.autocompleteAdminSuggestions(orgId, query);
  };
}
